/**
 * Small client-side helper that fires a Tealium `link` event for UI clicks.
 *
 * Mirrors the conventions used by `TealiumRouteTracker` (uses `window.utag`,
 * silently no-ops if utag.js hasn't loaded or is blocked, never throws).
 *
 * Usage:
 *   import { trackClick } from '../lib/track';
 *   trackClick('music-nav-trigger', { component: 'navbar', context: 'homepage' });
 */
export function trackClick(eventName, payload = {}) {
  if (!eventName || typeof window === 'undefined') return;
  const utag = window.utag;
  if (!utag || typeof utag.link !== 'function') return;
  try {
    utag.link({
      tealium_event: eventName,
      page_path:
        (typeof window.location !== 'undefined' && window.location.pathname) ||
        '',
      ExternalUid:
        (window.Parameters && window.Parameters.ExternalUid) || null,
      ...payload,
    });
  } catch (err) {
    // Analytics must never break the UI — but do surface in dev tools so
    // recurring failures are visible during debugging.
    if (typeof console !== 'undefined' && console.debug) {
      console.debug('[track] analytics dispatch failed', err);
    }
  }
}

export default { trackClick };
